import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  DoCheck,
} from '@angular/core';
import { UserMasterService } from '../../../services/user-master.service';
import { govevaFileManagerService } from '../../../services/govevaFileManager.service';
import { CompanyMasterService } from '../../../services/companymaster.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { GfmService } from '../../../services/gfm.service';
import { environment } from '../../../../environments/environment';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import {
  ActivatedRoute,
  RouterState,
  Router,
  NavigationEnd,
  UrlSerializer,
  UrlTree,
  DefaultUrlSerializer,
} from '@angular/router';
import { CommonFunction } from './../../../helpers/commonFunction';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TagPopupComponentComponent } from '../../govevaFileManager/tag-popup-component/tag-popup-component.component';
import { GfmconfirmationPopupComponent } from '../../govevaFileManager/gfmconfirmation-popup/gfmconfirmation-popup.component';

import { RoadmapModuleService } from '../../../services/roadmapModule.service';
import { TypeOfUser } from '../../../enums/TypeOfUser';
import * as _ from 'lodash';

import { GfmPopupforShareComponent } from '../../govevaFileManager/gfm-popupfor-share/gfm-popupfor-share.component';
import { safeJsonStringify } from '../../../shared/utils';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var $: any;
declare var NProgress: any;
declare var jQuery: any;

@Component({
  selector: 'app-gfm-dashboard',
  templateUrl: 'gfm-dashboard.component.html',
  styleUrls: ['./gfm-dashboard.component.css'],
})
export class GfmDashboardComponent implements OnInit, DoCheck {
  recordPath: any = ' ';
  fileList: any = [];
  recentFileList: any = [];
  folderList: any = [];
  shareList: any = [];
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  @ViewChild('pdfIframe')
  pdfIframe: ElementRef;
  searchResultsList: any = [];
  uploadForm = new FormGroup({
    folderName: new FormControl('', [
      Validators.required,
      Validators.pattern(new RegExp('^[a-zA-Z0-9_  -]+$')),
    ]),
    folderNameAfterRename: new FormControl('', [
      Validators.required,
      Validators.pattern(new RegExp('^[a-zA-Z0-9_  -]+$')),
    ]),
    fileName: new FormControl('', []),
    searchByValue: new FormControl('', []),
    multipleFileDocumentForUpload: new FormControl('', []),
  });
  filedata: any;
  fileName: any;
  token: any;
  companyID: any;
  companyName: any;
  complianceEngine: any;
  complianceEngineUrl: any;
  governanceUrl: any;
  recordDetails: any;
  uniqueUserId: any;
  userId: any;
  gemAccessUrl: any;
  folderName: any;
  multipleFileDocumentForUpload: any;
  count: any;
  uploadMultipleFileDocument: any = [];
  gfmResponse: any;
  recordNameAlreadyPresent: boolean = false;
  contextmenu: boolean = false;
  fileExtension: any;
  fileNameWithExtension: any;
  folderNameAfterRename: any;
  users: any = [];
  userListToBind: any = [];
  searchByType: any = 'NAME';
  searchByValue: any;
  isDeleteAllSelected: boolean = false;
  multipleRecordsListToDelete: any = [];
  isRecentFile: boolean = true;
  fileId: any;
  breadcrumbs: any = [];
  baseFileManagerPath: any = '';
  baseFileManagerRecordPathWithParams: any = '';
  params: any = '';
  sharedFileName: any = '';
  gfmRecordId: any = '';
  FileExtension: boolean = true;
  multifileExtension: boolean = true;
  loggedInUserUniqueId: any;

  showBreadCrumpath: boolean = false;
  showShareListDiv: boolean = false;
  folderNamePresentWhileRename: boolean = false;
  fileAfterRenameSame: boolean = false;

  gemAccessURL: any = '';

  showAddTagButtonForCreateFolder: boolean = false;
  selectedTagsForFolder: any = [];
  showAddTagDiv: boolean = false;

  showBreadcrumbs: boolean = false;
  renameFileDetails: any;

  isCompliance: boolean = false;
  gfmRecordIdForFolder: any = '';
  isComplianceFileParameter: any;
  showSpinner: boolean = false;
  sharedFolder: boolean = false;
  recordType: any = '';
  gfmRecordObject: any;
  gfmRecordArray: any = [];
  hierarchyArray: any = [];
  index = 0;
  globaluniqueUserId: any;
  isComplianceFileLink: any;
  SharedFolderUniqueUserId: any;
  isSharedFolder: any;

  GFMRootPath: any = '';
  disabledOnclick: boolean;
  files: any[] = [];
  
  // Properties for iframe file viewer
  iframeURL: SafeResourceUrl;
  title: any;
  showFileViewer: boolean = false;
  
  // Flag to control download access visibility
  allowDownloadAccess: boolean = true;
  
  // Tabbed table + pagination state
  activeTab: 'recent' | 'folders' | 'files' | 'shared' = 'files';
  pageSize: number = 5;
  recentPage: number = 1;
  foldersPage: number = 1;
  filesPage: number = 1;
  sharedPage: number = 1;

  // Move file/folder functionality
  selectedItemToMove: any = null;
  availableFolders: any[] = [];
  selectedDestinationFolder: any = null;
  parse(url: any): UrlTree {
    let dus = new DefaultUrlSerializer();
    return dus.parse(url);
  }

  serialize(tree: UrlTree): any {
    let dus = new DefaultUrlSerializer(),
      path = dus.serialize(tree);
    // use your regex to replace as per your requirement.
    return path.replace(/%2F/g, '/').replace(/%20/g, ' ');
  }

  // ===== Table Tabs + Pagination helpers =====
  setActiveTab(tab: 'recent' | 'folders' | 'files' | 'shared') {
    this.activeTab = tab;
    // reset page when switching
    if (tab === 'recent') { this.recentPage = 1; }
    if (tab === 'folders') { this.foldersPage = 1; }
    if (tab === 'files') { this.filesPage = 1; }
    if (tab === 'shared') { this.sharedPage = 1; }
  }

  private paginate<T>(items: T[], page: number): T[] {
    if (!items) { return []; }
    const start = (page - 1) * this.pageSize;
    return items.slice(start, start + this.pageSize);
  }

  get pagedRecentFiles() { return this.paginate(this.recentFileList || [], this.recentPage); }
  get pagedFolders() { return this.paginate(this.folderList || [], this.foldersPage); }
  get pagedFiles() { return this.paginate(this.fileList || [], this.filesPage); }
  get pagedShared() { const list = this.filterShareList(this.shareList || []); return this.paginate(list, this.sharedPage); }

  totalPages(list: any[]): number { return list && list.length ? Math.ceil(list.length / this.pageSize) : 1; }
  canPrev(tab: 'recent' | 'folders' | 'files' | 'shared') {
    return (tab === 'recent' && this.recentPage > 1)
        || (tab === 'folders' && this.foldersPage > 1)
        || (tab === 'files' && this.filesPage > 1)
        || (tab === 'shared' && this.sharedPage > 1);
  }
  canNext(tab: 'recent' | 'folders' | 'files' | 'shared') {
    if (tab === 'recent') return this.recentPage < this.totalPages(this.recentFileList || []);
    if (tab === 'folders') return this.foldersPage < this.totalPages(this.folderList || []);
    if (tab === 'files') return this.filesPage < this.totalPages(this.fileList || []);
    const list = this.filterShareList(this.shareList || []);
    return this.sharedPage < this.totalPages(list);
  }
  prevPage(tab: 'recent' | 'folders' | 'files' | 'shared') {
    if (tab === 'recent' && this.recentPage > 1) this.recentPage--;
    if (tab === 'folders' && this.foldersPage > 1) this.foldersPage--;
    if (tab === 'files' && this.filesPage > 1) this.filesPage--;
    if (tab === 'shared' && this.sharedPage > 1) this.sharedPage--;
  }
  nextPage(tab: 'recent' | 'folders' | 'files' | 'shared') {
    if (tab === 'recent' && this.canNext('recent')) this.recentPage++;
    if (tab === 'folders' && this.canNext('folders')) this.foldersPage++;
    if (tab === 'files' && this.canNext('files')) this.filesPage++;
    if (tab === 'shared' && this.canNext('shared')) this.sharedPage++;
  }

  constructor(
    private httpClient: HttpClient,
    private gfmservice: GfmService,
    private companyMasterService: CompanyMasterService,
    private meetingMasterService: MeetingMasterService,
    private userMasterService: UserMasterService,
    private gfmFilemanagerService: govevaFileManagerService,
    private modalService: NgbModal,
    private roadmapService: RoadmapModuleService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
     var userRolesArray=JSON.parse(localStorage.getItem('user')).Roles.map(role=>role.RoleName);
      if(userRolesArray.includes('Admin') || userRolesArray.includes('DFM-Actions')){
        this.allowDownloadAccess = true;
      }else{
        this.allowDownloadAccess = false;
      }
    this.GFMRootPath = environment.GFMRootPath;
    // console.log("this.GFMRootPath",this.GFMRootPath)
    var self = this;
    this.loggedInUserUniqueId = JSON.parse(
      localStorage.getItem('user')
    ).UniqueUserId;
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      this.isCompliance = params['isCompliance'];
      this.gfmRecordIdForFolder = params['gfmRecordId'];
      this.sharedFolder = params['sharedFolder'];
      if (this.isCompliance == undefined) {
        this.isCompliance = false;
      }
    });

    this.activatedRoute.params.subscribe((params) => {
      this.gfmRecordObject = {
        gfmRecordId: this.gfmRecordIdForFolder,
        path: params.internalPath,
      };
      if (this.gfmRecordId != undefined) {
        this.gfmRecordArray.push(this.gfmRecordObject);
        localStorage.setItem(
          'gfmRecordObject',
          safeJsonStringify(this.gfmRecordArray)
        );
        localStorage.setItem('gfmRecordId', this.gfmRecordIdForFolder);
        localStorage.setItem('path', params.internalPath);
      }

      this.params = params.internalPath;
      var newpath = this.params;
      if (newpath != undefined) {
        if (newpath.charAt(0) == '/') {
          newpath = newpath.substring(1, _.size(newpath));
        }
        this.breadcrumbs = newpath.split('/');
        if (_.size(this.breadcrumbs) > 0) {
          this.showBreadcrumbs = true;
        }
      }
    });

    let userInfo = JSON.parse(localStorage.getItem('user'));
    this.userId = JSON.parse(localStorage.getItem('user'))._id;
    this.uniqueUserId = JSON.parse(localStorage.getItem('user')).UniqueUserId;
    this.token = localStorage.getItem('token');
    this.companyID = JSON.parse(
      localStorage.getItem('companyDetails')
    ).companyID;
    this.companyName = JSON.parse(
      localStorage.getItem('companyDetails')
    ).companyName;
    this.governanceUrl = environment.nonValidateUrl;
    this.SharedFolderUniqueUserId = localStorage.getItem(
      'SharedFolderUniqueUserId'
    );
    this.isSharedFolder = localStorage.getItem('isSharedFolder');
    if (this.params != undefined) {
      var paramsSize = _.size(this.params);
      if (this.params.charAt(paramsSize - 1) == '/') {
        this.params = this.params.slice(0, -1);
      }
    } else {
      this.params = '';
    }
    // this.recordPath = "/home/ec2-user/GEM/GFM/" + this.uniqueUserId;
    // this.recordPath = this.GFMRootPath + this.uniqueUserId;
    this.recordPath = this.uniqueUserId;

    this.recordDetails = safeJsonStringify({
      recordPath: this.recordPath + this.params,
    });
    this.baseFileManagerPath = this.recordPath;
    this.baseFileManagerRecordPathWithParams = this.recordPath + this.params;

    this.companyMasterService
      .getCompanyList()
      .then((companyResponse) => {
        this.complianceEngine = companyResponse.companyData.ComplianceEngine;
        this.complianceEngineUrl =
          companyResponse.companyData.ComplianceEngineUrl;
        if (
          companyResponse.companyData.ClientLoginAPIUrl != undefined &&
          companyResponse.companyData.ClientLoginAPIUrl != '' &&
          _.size(companyResponse.companyData.ClientLoginAPIUrl) > 0
        ) {
          this.governanceUrl = companyResponse.companyData.ClientLoginAPIUrl;
        }

        if (
          companyResponse.companyData.GEMAccessURL != undefined &&
          companyResponse.companyData.GEMAccessURL != '' &&
          _.size(companyResponse.companyData.GEMAccessURL) > 0
        ) {
          this.gemAccessURL = companyResponse.companyData.GEMAccessURL;
        } else {
          //this.gemAccessURL = 'http://52.66.23.123:8085/api/';
          this.gemAccessURL = "http://" + environment.gemIp_domain + "/api/";
        }

        if (this.gfmRecordIdForFolder == undefined) {
          if (
            localStorage.getItem('isSharedFolder') == 'true' &&
            this.params != '/'
          ) {
            // this.recordPath = "/home/ec2-user/GEM/GFM/" + this.SharedFolderUniqueUserId;
            this.recordPath = this.GFMRootPath + this.SharedFolderUniqueUserId;
            this.recordDetails = safeJsonStringify({
              recordPath: this.recordPath + this.params,
            });
            this.getFilesAndFoldersAccordingToPath(
              this.recordDetails,
              this.complianceEngine,
              this.complianceEngineUrl,
              this.isCompliance
            );
          } else {
            this.getAllFilesAndFolders(
              this.recordDetails,
              this.complianceEngine,
              this.complianceEngineUrl,
              this.isCompliance
            );
          }
        } else {
          this.getAllFilesAndFoldersForSharedFolder(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.gfmRecordIdForFolder
          );
        }
      })
      .catch((error) => {});

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.getUserList();

    $(document).mouseup(function (e) {
      var container = $('.rightMenu');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && _.size(container.has(e.target)) === 0) {
        container.hide();
      }
    });
  }


  //parth
  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFile();
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler($event) {
    this.prepareFilesList($event);
  }

  getUserList() {
    this.roadmapService.getUserList().then((response) => {
      if (response.status == 0) {
        // console.log("response.result",response.result)
        response.result = response.result.filter(function (o) {
          return o.IsActive != false;
        });
        //check RoleName IC maker, IC Checker and remove it from report to list
        response.result = response.result.filter(function (userElement) {
          return (
            _.get(_.first(userElement.Roles), 'RoleName') != 'IC Maker' &&
            _.get(_.first(userElement.Roles), 'RoleName') != 'IC Checker'
          );
        });

        var users = response.result;
        users = response.result.filter((user)=>{return user.CompanyId == this.companyID});

        this.userListToBind = users.map(function (user) {
          return {
            label: user.FirstName + ' ' + user.LastName,
            value: user._id,
            unqiueUserId: user.UniqueUserId,
          };
        });
      } else {
      }
    });
  }

  getAllFilesAndFolders(
    recordDetails,
    complianceEngine,
    complianceEngineUrl,
    isCompliance
  ) {
    this.showSpinner = true;
    this.gfmservice
      .getAllFilesAndFolders(
        recordDetails,
        complianceEngine,
        complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        isCompliance
      )
      .then((response) => {
        this.showSpinner = false;
        if (!response) {
          this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
          this.fileList = [];
          this.recentFileList = [];
          this.folderList = [];
          this.shareList = [];
          return;
        }
        this.gfmResponse = response;
        this.fileList = this.gfmResponse.allFilesList || [];
        this.recentFileList = this.gfmResponse.allRecentFilesList || [];
        if (_.size(this.recentFileList) > 0) {
          for (var i = 0; i < _.size(this.recentFileList); i++) {
            this.recentFileList[i].isRecentFile = true;
          }
        }
        this.folderList = this.gfmResponse.allFoldersList || [];
        this.shareList = this.gfmResponse.allSharedWithFilesList || [];

        this.fileList = this.fileList ? this.fileList.filter((file)=>{return file.companyId == this.companyID}) : this.fileList;
        this.recentFileList = this.recentFileList ? this.recentFileList.filter((file)=>{return file.companyId == this.companyID}) : this.recentFileList;
        this.folderList = this.folderList ? this.folderList.filter((file)=>{return file.companyId == this.companyID}) : this.folderList;
        this.shareList = this.shareList ? this.shareList.filter((file)=>{return file.companyId == this.companyID}) : this.shareList;

        console.log(this.fileList, this.shareList);

        if (_.size(this.shareList) > 0) {
          this.showShareListDiv = true;
        } else {
          this.showShareListDiv = false;
        }

        if (_.size(this.shareList) > 0) {
          this.showShareListDiv = true;
        } else {
          this.showShareListDiv = false;
        }
      })
      .catch((error) => {
        this.showSpinner = false;
        console.error('Error fetching files and folders:', error);
        this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
        this.fileList = [];
        this.recentFileList = [];
        this.folderList = [];
        this.shareList = [];
      });
  }

  getAllFilesAndFoldersForSharedFolder(
    recordDetails,
    complianceEngine,
    complianceEngineUrl,
    gfmRecordIdForFolder
  ) {
    this.showSpinner = true;
    this.gfmservice
      .getAllFilesAndFoldersForSharedFolder(
        recordDetails,
        complianceEngine,
        complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        gfmRecordIdForFolder
      )
      .then((response) => {
        this.showSpinner = false;
        if (!response) {
          this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
          this.fileList = [];
          this.recentFileList = [];
          this.folderList = [];
          this.shareList = [];
          return;
        }
        this.gfmResponse = response;
        this.fileList = this.gfmResponse.allFilesList || [];
        this.recentFileList = this.gfmResponse.allRecentFilesList || [];
        if (_.size(this.recentFileList) > 0) {
          for (var i = 0; i < _.size(this.recentFileList); i++) {
            this.recentFileList[i].isRecentFile = true;
          }
        }
        this.folderList = this.gfmResponse.allFoldersList || [];
        this.shareList = this.gfmResponse.allSharedWithFilesList || [];

        this.fileList = this.fileList ? this.fileList.filter((file)=>{return file.companyId == this.companyID})  :this.fileList;
        this.recentFileList = this.recentFileList ? this.recentFileList.filter((file)=>{return file.companyId == this.companyID}) : this.recentFileList;
        this.folderList = this.folderList ? this.folderList.filter((file)=>{return file.companyId == this.companyID}) : this.folderList;
        this.shareList = this.shareList ? this.shareList.filter((file)=>{return file.companyId == this.companyID}) : this.shareList;

        if (_.size(this.shareList) > 0) {
          this.showShareListDiv = true;
        } else {
          this.showShareListDiv = false;
        }
      })
      .catch((error) => {
        this.showSpinner = false;
        console.error('Error fetching shared files and folders:', error);
        this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
        this.fileList = [];
        this.recentFileList = [];
        this.folderList = [];
        this.shareList = [];
      });
  }

  getFilesAndFoldersAccordingToPath(
    recordDetails,
    complianceEngine,
    complianceEngineUrl,
    isCompliance
  ) {
    this.showSpinner = true;
    this.gfmservice
      .getFilesAndFoldersAccordingToPath(
        recordDetails,
        complianceEngine,
        complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        isCompliance
      )
      .then((response) => {
        this.showSpinner = false;
        if (!response) {
          this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
          this.fileList = [];
          this.recentFileList = [];
          this.folderList = [];
          this.shareList = [];
          return;
        }
        this.gfmResponse = response;
        this.fileList = this.gfmResponse.allFilesList || [];
        this.recentFileList = this.gfmResponse.allRecentFilesList || [];
        if (_.size(this.recentFileList) > 0) {
          for (var i = 0; i < _.size(this.recentFileList); i++) {
            this.recentFileList[i].isRecentFile = true;
          }
        }
        this.folderList = this.gfmResponse.allFoldersList || [];
        this.shareList = this.gfmResponse.allSharedWithFilesList || [];

        this.fileList = this.fileList ? this.fileList.filter((file)=>{return file.companyId == this.companyID}) : this.fileList;
        this.recentFileList = this.recentFileList ? this.recentFileList.filter((file)=>{return file.companyId == this.companyID}) : this.recentFileList;
        this.folderList = this.folderList ? this.folderList.filter((file)=>{return file.companyId == this.companyID}) : this.folderList;
        this.shareList = this.shareList ? this.shareList.filter((file)=>{return file.companyId == this.companyID}) : this.shareList;

        if (_.size(this.shareList) > 0) {
          this.showShareListDiv = true;
        } else {
          this.showShareListDiv = false;
        }
      })
      .catch((error) => {
        this.showSpinner = false;
        console.error('Error fetching files and folders by path:', error);
        this.gfmResponse = { allFilesList: [], allFoldersList: [], allRecentFilesList: [], allSharedWithFilesList: [] };
        this.fileList = [];
        this.recentFileList = [];
        this.folderList = [];
        this.shareList = [];
      });
  }

  closeForm(id) {
    $('#' + id).modal('toggle');
    this.ngOnInit();
  }

  fileEvent(event) {
    console.log('this.filedata', this.filedata);
    var checkfile = this.commonFunction.checkFileExtension(event);
    if (checkfile) {
      this.filedata = <File>event.target.files[0];
      this.uploadFile();
      this.FileExtension = true;
    } else {
      this.FileExtension = false;
      var self = this;
      var modal = document.getElementById('myModal');
      modal.style.display = 'none';
      const modalRef = this.modalService.open(GfmconfirmationPopupComponent, {
        backdrop: 'static',
      });
      var message = 'Please upload valid file format.';
      modalRef.componentInstance.Message = message;
    }
    // this.filedata = <File>event.target.files[0];
  }

  uploadFile() {
    this.showSpinner=true;
    let formData = new FormData();
    for (let file of this.files) {
      formData.append('file', file);
    }
    
    this.gfmservice
      .postFileUploadForGFM(
        this.files,
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL
      )
      .then((response) => {
        this.showSpinner=false;
        if (response == 409) {
          $('#uploadedSingleFileAlreadyPresent').modal('toggle');
        }
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
      })
      .catch((error) => {});
    this.files.length = 0;  
  }

  deleteSelectedFile(event, file, index) {
    var checkthis = this.uploadMultipleFileDocument.splice(index, 1);
    var filesList: FileList = <FileList>this.uploadMultipleFileDocument;
    if (_.size(filesList) > 0) {
    } else {
      this.showAddTagButtonForCreateFolder = false;
    }
  }

  addNewFolder() {
    this.selectedTagsForFolder = [];
    this.showAddTagButtonForCreateFolder = false;
    this.uploadForm.controls.folderName.reset();
    this.multipleFileDocumentForUpload = '';
    this.uploadMultipleFileDocument = [];
    $('#myModal').modal('toggle');
  }

  multipleFileEvent(event) {
    var self = this;
    this.count = _.size(event.target.files);
    var i;
    for (i = 0; i < this.count; i++) {
      var checkfile = this.commonFunction.checkFileExtension(event);
      if (checkfile) {
        self.uploadMultipleFileDocument.push(<File>event.target.files[i]);
        this.multifileExtension = true;
      } else {
        this.multifileExtension = false;
      }
    }
    if (_.size(event.target.files) > 0) {
      this.showAddTagButtonForCreateFolder = true;
    } else {
      this.showAddTagButtonForCreateFolder = false;
    }
    if (_.size(self.uploadMultipleFileDocument) > 0) {
      self.uploadMultipleFileDocument = _.uniqBy(
        self.uploadMultipleFileDocument,
        'name'
      );
    }
  }

  getFolderName(event) {
    this.folderName = event.target.value;
    var self = this;
    var i;
    if (!this.gfmResponse || !this.gfmResponse.allFoldersList) {
      this.recordNameAlreadyPresent = false;
      return;
    }
    var allFoldersListFiltered = this.gfmResponse.allFoldersList.filter((folder)=>{ return folder.companyId == this.companyID})
    if (!_.isUndefined(this.gfmResponse)) {
      if (_.size(allFoldersListFiltered) > 1) {
        for (i = 0; i < _.size(allFoldersListFiltered); i++) {
          if (
            this.folderName.toLowerCase() ==
            allFoldersListFiltered[i].recordName.toLowerCase()
          ) {
            self.recordNameAlreadyPresent = true;
            return;
          } else {
            self.recordNameAlreadyPresent = false;
          }
        }
      }
    }
    if (event.target.value.trim() == '') {
      this.uploadForm.controls.folderName.setValue(event.target.value.trim());
      this.uploadForm.controls.folderName.updateValueAndValidity();
    }
  }

  saveFolderNameWithFileUplaod() {
    this.disabledOnclick = true;
    var self = this;
    var tempPath = JSON.parse(this.recordDetails);
    let formData = new FormData();

    var tagsForFolder = [];
    if (_.size(this.selectedTagsForFolder) > 0) {
      _.forEach(self.selectedTagsForFolder, function (tag) {
        tagsForFolder.push(tag.value);
      });
    }

    //This was added for Dream11 they wanted multiple fileswith same name to be created in differentcompanies
    //GEM does not directly support above requiremnet
    //alternate solution that is implemented is to add a company name prefix to the folder name
    this.folderName = this.companyName + "-" + this.folderName;

    this.recordDetails = safeJsonStringify({
      action: 'create',
      recordName: this.folderName,
      //"recordPath": "/home/ec2-user/GEM/GFM/" + this.uniqueUserId
      recordPath: tempPath.recordPath,
      tags: tagsForFolder,
    });

    this.gfmservice
      .createFolderForGFM(
        this.filedata,
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL
      )
      .then((response) => {
        this.disabledOnclick = false;
        // console.log("response.recordName", response.gfmRecordrecordName)
        if (response) {
          this.recordDetails = safeJsonStringify({
            recordPath:
              tempPath.recordPath + '/' + response.gfmRecord.recordName,
            tags: tagsForFolder,
          });

          // console.log("this.recordDetails",this.recordDetails)

          var count1 = _.size(this.uploadMultipleFileDocument);
          var i = 0;
          for (i = 0; i < count1; i++) {
            formData.append('files', this.uploadMultipleFileDocument[i]);
          }
          formData.append('recordDetails', this.recordDetails);

          this.gfmservice
            .postMultipleFileUploadForGFM(
              formData,
              this.recordDetails,
              this.complianceEngine,
              this.complianceEngineUrl,
              this.governanceUrl,
              this.gemAccessURL
            )
            .then((response) => {
              if (response) {
                this.recordDetails = safeJsonStringify({
                  recordPath: tempPath.recordPath,
                });
                this.showSpinner = true;
                this.gfmservice
                  .getAllFilesAndFolders(
                    this.recordDetails,
                    this.complianceEngine,
                    this.complianceEngineUrl,
                    this.governanceUrl,
                    this.gemAccessURL,
                    this.isCompliance
                  )
                  .then((response) => {
                    this.showSpinner = false;
                    $('#myModal').modal('toggle');
                    if (response) {
                      $('#folderCreatedSuccessfully').modal('toggle');
                      this.gfmResponse = response;
                      if (_.size(this.gfmResponse.allFoldersList) == 0) {
                      }
                      this.fileList = this.gfmResponse.allFilesList;
                      this.recentFileList = this.gfmResponse.allRecentFilesList;
                      this.folderList = this.gfmResponse.allFoldersList;

                      this.fileList = this.fileList ? this.fileList.filter((file)=>{return file.companyId == this.companyID}) : this.fileList;
                      this.recentFileList = this.recentFileList ? this.recentFileList.filter((file)=>{return file.companyId == this.companyID}) : this.recentFileList;
                      this.folderList = this.folderList ? this.folderList.filter((file)=>{return file.companyId == this.companyID}) : this.folderList;
                      this.shareList = this.shareList ? this.shareList.filter((file)=>{return file.companyId == this.companyID}) : this.shareList;

                    }
                  });
              }
            });
        }
      });
  }

  getSelectedFolderFileList(folder, isSharedFolder, i) {
    if (_.size(this.breadcrumbs) == 1 && isSharedFolder == 'true') {
      localStorage.setItem('isSharedFolder', isSharedFolder);
    }
    this.shareRecords = isSharedFolder;
    localStorage.setItem('SharedFolderUniqueUserId', folder.uniqueUserId);
    this.isCompliance = folder.isComplianceFile;
    this.gfmRecordIdForFolder = folder.gfmRecordId;
    this.recordPath = folder.recordPath;
    var input = this.recordPath;
    var period = input.lastIndexOf('/');
    var pluginName = input.substring(0, period);
    this.fileExtension = input.substring(period + 1);
    var index = index + 1;

    var object = {
      gfmRecordIdForFolder: folder.gfmRecordId,
      recordName: folder.recordName,
      recordPath: folder.recordPath,
      isSharedFolder: isSharedFolder,
      index: index,
    };
    this.hierarchyArray.push({
      gfmRecordIdForFolder: folder.gfmRecordId,
      recordName: folder.recordName,
      recordPath: folder.recordPath,
      isSharedFolder: isSharedFolder,
      index: index,
    });

    if (this.fileExtension == folder.recordName) {
      // this.recordPath = "/home/ec2-user/GEM/GFM/" + folder.uniqueUserId;
      this.recordPath = this.GFMRootPath + folder.uniqueUserId;

      this.baseFileManagerPath = this.recordPath;
      this.recordPath = environment.GFMRootPath + folder.recordPath;
    } else {
      // this.baseFileManagerPath = folder.recordPath
      // this.recordPath = "/home/ec2-user/GEM/GFM/" + folder.uniqueUserId;
      this.recordPath = this.GFMRootPath + folder.uniqueUserId;

      this.baseFileManagerPath = this.recordPath;
      this.recordPath =
        environment.GFMRootPath + folder.recordPath + '/' + folder.recordName;
    }
    var sampleArray = [];
    sampleArray.push(folder);
    localStorage.setItem('sampleArray', _.toString(sampleArray));
    this.recordDetails = safeJsonStringify({
      recordPath: this.recordPath,
    });

    index = this.recordPath.indexOf(this.baseFileManagerPath);
    var pathstring = this.recordPath;
    var path = '';
    var newpath = '';
    if (index >= 0) {
      path = this.recordPath.slice(index, _.size(this.baseFileManagerPath));
      // var newpath = "";
      newpath = pathstring.substring(_.size(path), _.size(this.recordPath));
    } else {
      var firstSlashPosition = folder.recordPath.search('/') + 1;
      newpath = folder.recordPath.slice(firstSlashPosition);
    }

    if (isSharedFolder == 'true') {
      this.globaluniqueUserId = folder.uniqueUserId;
    }
    /*
    if (newpath.charAt(0) == '/') {
      newpath = newpath.substring(1, _.size(newpath));
    }

    if (newpath.charAt((_.size(newpath) - 1)) == '/') {
      newpath = newpath.substring(_.size(newpath) - 1, -1)
    }*/

    this.breadcrumbs = newpath.split('/');
    newpath = newpath.trim();
    var newLink = this.serialize(this.parse(newpath));
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    if (
      isSharedFolder == 'true' ||
      localStorage.getItem('isSharedFolder') == 'true'
    ) {
      this.router.navigate(
        [
          'structure',
          { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
        ],
        {
          queryParams: {
            gfmRecordId: this.gfmRecordIdForFolder,
            sharedFolder: 'true',
          },
        }
      );
    } else {
      this.router.navigate(
        [
          'structure',
          { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
        ],
        { queryParams: { isCompliance: this.isCompliance } }
      );
    }
    // //console.log("this.recordDetails", this.recordDetails)
    // below code has been commenedted out as breadcrum list will handle the reinitialisation part for the folders to be fetched
    // this.getAllFilesAndFolders(this.recordDetails, this.complianceEngine, this.complianceEngineUrl)
  }

  showRecentFileMenu(file, i, menuName) {
    $('#' + menuName + i).toggle('show');
  }

  showFolderMenu(file, i, menuName) {
    $('#' + menuName + i).toggle('show');
  }

  showAllFileMenu(file, i, menuName) {
    $('#' + menuName + i).toggle('show');
  }

  showShareFileMenu(file, i, menuName) {
    $('#' + menuName + i).toggle('show');
  }

  // rename file
  renameFileDialogBox(file, i, menuName) {
    this.fileAfterRenameSame = false;
    this.renameFileDetails = new Object();
    this.renameFileDetails = file;
    var tempPath = JSON.parse(this.recordDetails);
    $('#' + menuName + i).toggle('hide');
    this.fileNameWithExtension = file.recordName;
    this.recordPath = file.recordPath;
    var input = this.recordPath;
    var period = input.lastIndexOf('/');
    var pluginName = input.substring(0, period);
    this.fileExtension = input.substring(period + 1);

    if (this.fileExtension == this.fileNameWithExtension) {
      this.recordPath = pluginName;
    } else {
    }
    this.fileName = file.recordName;
    var inputs = this.fileName;
    var periods = inputs.lastIndexOf('.');
    var pluginNames = inputs.substring(0, periods);
    this.fileExtension = inputs.substring(periods + 1);
    this.fileName = pluginNames;
    $('#renameFileModal').modal('toggle');
  }

  renameFolderDialogBox(folder, i, menuName) {
    this.folderNamePresentWhileRename = false;
    $('#' + menuName + i).toggle('hide');
    $('#renameFolderModal').modal('toggle');
    this.folderNameAfterRename = folder.recordName;
    this.folderName = folder.recordName;
  }

  ngDoCheck() {
    if (_.size(this.breadcrumbs) <= 0) {
      // this.showBreadCrumpath = false;
    } else {
      if (_.size(this.breadcrumbs) == 1 && this.breadcrumbs[0] == '') {
        this.showBreadCrumpath = false;
      } else {
        this.showBreadCrumpath = true;
      }
    }
    if (_.size(this.selectedTagsForFolder) > 0) {
      this.showAddTagDiv = true;
    } else {
      this.showAddTagDiv = false;
    }
  }

  getNewFileName(event) {
    var fileRename = event.target.value;
    var self = this;
    var i;
    var input = this.fileNameWithExtension;
    var period = input.lastIndexOf('.');
    var pluginName = input.substring(0, period);
    var fileExtension = input.substring(period + 1);
    fileRename = fileRename + '.' + fileExtension;
    if (_.size(this.gfmResponse.allFilesList) > 0) {
      for (i = 0; i < _.size(this.gfmResponse.allFilesList); i++) {
        this.fileName = this.gfmResponse.allFilesList[i].recordName;
        if (fileRename == this.fileName) {
          this.fileAfterRenameSame = true;
          i = _.size(this.gfmResponse.allFilesList);
        } else {
          this.fileAfterRenameSame = false;
        }
      }
    }
    if (event.target.value.trim() == '') {
      this.uploadForm.controls.fileName.setValue(event.target.value.trim());
      this.uploadForm.controls.fileName.updateValueAndValidity();
    }
    this.fileName = event.target.value;
  }

  getNewFolderName(event) {
    var folderRename = event.target.value;
    var self = this;
    var i;
    if (!this.gfmResponse || !this.gfmResponse.allFoldersList) {
      this.folderNamePresentWhileRename = false;
      return;
    }
    var allFoldersListFiltered = this.gfmResponse.allFoldersList.filter((folder)=>{ return folder.companyId == this.companyID})
    if (_.size(allFoldersListFiltered) > 0) {
      for (i = 0; i < _.size(allFoldersListFiltered); i++) {
        if (
          folderRename.toLowerCase() ==
          allFoldersListFiltered[i].recordName.toLowerCase()
        ) {
          self.folderNamePresentWhileRename = true;
          return;
        } else {
          self.folderNamePresentWhileRename = false;
          this.folderNameAfterRename = event.target.value;
        }
      }
    }
  }

  renameFileName() {
    $('#renameFileModal').modal('toggle');
    var tempPath = JSON.parse(this.recordDetails);
    this.fileName = this.fileName.trim() + '.' + this.fileExtension;
    // this.recordPath = this.GFMRootPath + this.uniqueUserId;
    this.recordPath = this.uniqueUserId + this.params;
    this.recordDetails = safeJsonStringify({
      action: 'rename',
      recordName: this.fileNameWithExtension,
      recordPath: this.recordPath,
      renameRecordName: this.fileName.trim(),
    });

    this.isComplianceFileParameter = this.renameFileDetails.isComplianceFile;
    this.gfmservice
      .renameOrRemoveFiles(
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        this.isComplianceFileParameter
      )
      .then((response) => {
        if (response.status != 500) {
          this.recordDetails = safeJsonStringify({
            recordPath: tempPath.recordPath,
          });
          $('#renameFolderModalSuccessfull').modal('toggle');
          this.getAllFilesAndFolders(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.isCompliance
          );
        } else {
          this.recordDetails = safeJsonStringify({
            recordPath: tempPath.recordPath,
          });
        }
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
      })
      .catch((error) => {
        this.recordDetails = safeJsonStringify({
          recordPath: tempPath.recordPath,
        });
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
      });
  }

  renameFolderName() {
    $('#renameFolderModal').modal('toggle');
    var tempPath = JSON.parse(this.recordDetails);
    var updatedFolderName = this.companyName + "-" + this.folderNameAfterRename.trim();
    this.recordDetails = safeJsonStringify({
      action: 'rename',
      recordName: this.folderName,
      recordPath: tempPath.recordPath,
      renameRecordName: updatedFolderName,
    });
    this.gfmservice
      .createFolderForGFM(
        this.filedata,
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL
      )
      .then((response) => {
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
      });
  }

  // delete file
  confirmDeleteFileDialogBox(file, i) {
    var tempPath = JSON.parse(this.recordDetails);
    $('#' + i).toggle('show');
    this.fileName = file.recordName;
    this.recordPath = file.recordPath;
    var input = this.recordPath;
    var period = input.lastIndexOf('/');
    var pluginName = input.substring(0, period);
    this.fileExtension = input.substring(period + 1);
    if (file.recordName == this.fileExtension) {
      this.recordPath = pluginName;
    } else {
    }
    this.isComplianceFileParameter = file.isComplianceFile;
    $('#deleteFileModel').modal('toggle');
  }

  confirmDeleteSharedFileDialogBox(file, i) {
    this.recordType = file.recordType;
    $('#' + i).toggle('show');
    this.sharedFileName = file.recordName;
    this.gfmRecordId = file.gfmRecordId;
    this.uniqueUserId = file.uniqueUserId;
    if (this.sharedFolder == undefined) {
    } else {
      this.recordDetails = safeJsonStringify({
        recordPath: file.recordPath,
      });
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      this.gfmRecordIdForFolder = params['gfmRecordId'];
      this.sharedFolder = params['sharedFolder'];
    });
    $('#deleteSharedFileModel').modal('toggle');
  }

  confirmDeleteSharedFile() {
    $('#deleteSharedFileModel').modal('toggle');
    if (this.recordType == 'folder') {
      this.gfmservice
        .folderRemovalBySharedUser(
          this.complianceEngine,
          this.complianceEngineUrl,
          this.gfmRecordId,
          this.governanceUrl,
          this.gemAccessURL
        )
        .then((response) => {
          if (response) {
            this.showSuccess('Shared folder deleted successfully');
            if (this.sharedFolder) {
              this.getAllFilesAndFoldersForSharedFolder(
                this.recordDetails,
                this.complianceEngine,
                this.complianceEngineUrl,
                this.gfmRecordIdForFolder
              );
            } else {
              this.getAllFilesAndFolders(
                this.recordDetails,
                this.complianceEngine,
                this.complianceEngineUrl,
                this.isCompliance
              );
            }
          }
        })
        .catch((error) => { this.showError('Failed to delete shared folder'); });
    } else {
      this.gfmservice
        .fileRemovalBySharedUser(
          this.complianceEngine,
          this.complianceEngineUrl,
          this.gfmRecordId,
          this.governanceUrl,
          this.gemAccessURL
        )
        .then((response) => {
          if (response) {
            this.showSuccess('Shared file deleted successfully');
            if (this.sharedFolder) {
              this.getAllFilesAndFoldersForSharedFolder(
                this.recordDetails,
                this.complianceEngine,
                this.complianceEngineUrl,
                this.gfmRecordIdForFolder
              );
            } else {
              this.getAllFilesAndFolders(
                this.recordDetails,
                this.complianceEngine,
                this.complianceEngineUrl,
                this.isCompliance
              );
            }
          }
        })
        .catch((error) => { this.showError('Failed to delete shared file'); });
    }
  }

  confirmDeleteFile() {
    $('#deleteFileModel').modal('toggle');
    var tempPath = JSON.parse(this.recordDetails);
    this.recordPath = this.uniqueUserId + this.params;
    this.recordDetails = safeJsonStringify({
      action: 'remove',
      recordName: this.fileName,
      recordPath: this.recordPath,
    });

    this.gfmservice
      .renameOrRemoveFiles(
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        this.isComplianceFileParameter
      )
      .then((response) => {
        this.recordDetails = safeJsonStringify({
          action: 'remove',
          recordName: this.fileName,
          recordPath: tempPath.recordPath,
        });
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
        this.showSuccess('File deleted successfully');
      })
      .catch((error) => { this.showError('Failed to delete file'); });
  }

  // delete folder
  confirmDeleteFolderDialogBox(folder) {
    this.folderName = folder.recordName;
    $('#deleteFolderModel').modal('toggle');
  }

  confirmDeleteFolder() {
    $('#deleteFolderModel').modal('toggle');
    var tempPath = JSON.parse(this.recordDetails);
    this.recordDetails = safeJsonStringify({
      action: 'remove',
      recordName: this.folderName,
      recordPath: tempPath.recordPath,
    });
    this.gfmservice
      .createFolderForGFM(
        this.filedata,
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL
      )
      .then((response) => {
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
        this.showSuccess('Folder deleted successfully');
      })
      .catch((error) => { this.showError('Failed to delete folder'); });
  }

  // this will short the name if it is longer than set character
  sendShortName(fileRecordName) {
    if (_.size(fileRecordName) > 20) {
      return fileRecordName.substring(0, 20) + '...';
    } else {
      return fileRecordName;
    }
  }

  openTagPopupComponent(fileDetail, index, menuName) {
    var self = this;
    $('#' + menuName + index).toggle('hide');
    const modalRef = this.modalService.open(TagPopupComponentComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.fileDetail = fileDetail;
    modalRef.componentInstance.complianceEngine = this.complianceEngine;
    modalRef.componentInstance.complianceEngineUrl = this.complianceEngineUrl;
    modalRef.componentInstance.gfmRecordId = this.fileId;
    modalRef.componentInstance.governanceUrl = this.governanceUrl;
    modalRef.componentInstance.gemAccessURL = this.gemAccessURL;
    modalRef.componentInstance.isFolderCreation = false;
    modalRef.componentInstance.tagPopupCloseParameter.subscribe(
      (receivedEntry) => {
        self.navigationFunction(receivedEntry);
      }
    );
    modalRef.result.then((resp) => {});
  }

  // share file
  shareFileDialogBox(file, i) {
    // $('#' + i).toggle('show')
    this.fileId = file.gfmRecordId;
    var recordName = file.recordName;
    var complianceDocumentId = file.complianceDocumentId;
    const modalRef = this.modalService.open(GfmPopupforShareComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.ObjectToSend = this.userListToBind;
    modalRef.componentInstance.recordDetails = this.recordDetails;
    modalRef.componentInstance.recordName = recordName;
    modalRef.componentInstance.complianceEngine = this.complianceEngine;
    modalRef.componentInstance.complianceEngineUrl = this.complianceEngineUrl;
    modalRef.componentInstance.gfmRecordId = this.fileId;
    modalRef.componentInstance.fileDetails = file;
    modalRef.componentInstance.governanceUrl = this.governanceUrl;
    modalRef.componentInstance.complianceDocumentId = complianceDocumentId;
    modalRef.componentInstance.gemAccessURL = this.gemAccessURL;
    modalRef.componentInstance.sharedFolder = this.sharedFolder;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.gfmRecordIdForFolder = params['gfmRecordId'];
      this.sharedFolder = params['sharedFolder'];
    });
    modalRef.result.then(
      (resp) => {
        if (this.sharedFolder) {
          this.getAllFilesAndFoldersForSharedFolder(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.gfmRecordIdForFolder
          );
        } else {
          this.getAllFilesAndFolders(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.isCompliance
          );
        }
      },
      (error) => {
        if (this.sharedFolder) {
          this.getAllFilesAndFoldersForSharedFolder(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.gfmRecordIdForFolder
          );
        } else {
          this.getAllFilesAndFolders(
            this.recordDetails,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.isCompliance
          );
        }
      }
    );
  }

  getTypeToSerch(event) {
    this.searchByType = event.target.innerText;
  }

  searchFileName(event) {
    var regex = new RegExp('^[a-zA-Z0-9_  -]+$');

    console.log(regex.exec(event.target.value.trim()));
    if (event.target.value.trim() == '') {
      this.uploadForm.controls.searchByValue.setValue(
        event.target.value.trim().replace(regex, '')
      );
      this.uploadForm.controls.searchByValue.updateValueAndValidity();
      this.searchByValue = event.target.value.replace(regex, '');
    } else {
      this.uploadForm.controls.searchByValue.setValue(
        event.target.value.trim()
      );
      this.uploadForm.controls.searchByValue.updateValueAndValidity();
      this.searchByValue = event.target.value.trim();
    }
    var tempPath = JSON.parse(this.recordDetails);
    this.recordDetails = safeJsonStringify({
      action: this.searchByType.toLowerCase(),
      recordName: this.searchByValue,
      recordPath: tempPath.recordPath,
    });
    if (
      this.searchByValue != null &&
      this.searchByValue != undefined &&
      this.searchByValue != ''
    ) {
      this.gfmservice
        .searchFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.governanceUrl,
          this.gemAccessURL
        )
        .then((response) => {
          //this.searchResultsList = response.allSearchResultsList;

          var searchRespose = response;
          searchRespose.allFoldersList = response.allFoldersList ? 
                  searchRespose.allFoldersList.filter((f)=>{return f.companyId==this.companyID}) :  response.allFoldersList;
          searchRespose.allFilesList = response.allFilesList ? 
                  searchRespose.allFilesList.filter((f)=>{return f.companyId==this.companyID}) : response.allFilesList;
          searchRespose.allRecentFilesList = response.allRecentFilesList ? 
                  searchRespose.allRecentFilesList.filter((f)=>{return f.companyId==this.companyID}) : response.allRecentFilesList;
          searchRespose.allSharedWithFilesList = response.allSharedWithFilesList ? 
                  searchRespose.allSharedWithFilesList.filter((f)=>{return f.companyId==this.companyID}) : response.allSharedWithFilesList;
          searchRespose.allSearchResultsList = response.allSearchResultsList ? 
                  searchRespose.allSearchResultsList.filter((f)=>{return f.companyId==this.companyID}) : response.allSearchResultsList;
         
          this.searchResultsList = searchRespose.allSearchResultsList;

          if (this.searchResultsList.length) {
            $('.backgroundBlur').addClass('blur-filter');
          } else {
            $('.backgroundBlur').removeClass('blur-filter');
          }
        });
    } else {
      this.searchResultsList = [];
      $('.backgroundBlur').removeClass('blur-filter');
    }
  }

  deleteSelectedRecords(data) {
    this.isDeleteAllSelected = true;
  }

  cancleSelectedList() {
    this.isDeleteAllSelected = false;
  }

  confirmMultipleDelete() {
    $('#confirmMultipleDelete').modal('toggle');
  }

  getCheckedRecords(event, data) {
    if (data.isRecentFile == true) {
      data.recordPath = data.recordPath + '/' + data.recordName;
    }
    if (event.target.checked == true) {
      this.multipleRecordsListToDelete.push(data);
    } else {
      let indexOfItem = this.multipleRecordsListToDelete.findIndex(
        (o) => o.gfmRecordId === data.gfmRecordId
      );
      if (_.size(this.multipleRecordsListToDelete) > 0) {
        for (var i = 0; i < _.size(this.multipleRecordsListToDelete); i++) {
          if (
            this.multipleRecordsListToDelete[i].gfmRecordId == data.gfmRecordId
          ) {
          }
        }
      }
      if (indexOfItem > -1) {
        this.multipleRecordsListToDelete.splice(indexOfItem, 1);
      }
    }
    this.multipleRecordsListToDelete = _.uniqBy(
      this.multipleRecordsListToDelete,
      'gfmRecordId'
    );
  }

  deleteMultipleRecords() {
    var tempPath = JSON.parse(this.recordDetails);
    this.recordDetails = safeJsonStringify({
      allGFMRecords: this.multipleRecordsListToDelete,
    });
    this.gfmservice
      .multipleRemovalOfFilesAndFolders(
        this.recordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL
      )
      .then((response) => {
        $('#confirmMultipleDelete').modal('toggle');
        this.recordDetails = safeJsonStringify({
          recordPath: tempPath.recordPath,
        });
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
        this.isDeleteAllSelected = false;
      });
  }

  downloadGFMFileDialogBox(fileDetails, index, menuName, isShared) {
    this.isComplianceFileLink = fileDetails.link;
    this.gfmRecordId = fileDetails.gfmRecordId;
    $(document).mouseup(function (e) {
      var container = $('#' + menuName + index);
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && _.size(container.has(e.target)) === 0) {
        container.hide();
      }
    });
    /*    if (isShared =='true') {
      var path = `${fileDetails.recordPath}/${fileDetails.recordName}`
    }
    else {
      path = fileDetails.recordPath;

    }*/
    var path = `${fileDetails.recordPath}/${fileDetails.recordName}`;
    var stringLocation = path.indexOf(fileDetails.recordName);
    var recordPath = '';
    if (stringLocation >= 0) {
      recordPath = path.substring(stringLocation - 1, -1);
    } else {
      // recordPath = fileDetails.recordPath;
      recordPath = path;
    }
    //console.log('path',path)
    var object = {
      recordName: fileDetails.recordName,
      recordPath: recordPath,
      id: fileDetails.recordType == "folder" ? undefined : fileDetails.recordPath.split('/')[0]
    };
    if (fileDetails.recordType == 'file') {
      if (fileDetails.isComplianceFile == true) {
        this.gfmservice
          .downloadComplianceFile(
            object,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.governanceUrl,
            this.gemAccessURL,
            isShared,
            this.isComplianceFileLink
          )
          .then((responseDownloadFile) => {
            var blob = new Blob();
            blob = responseDownloadFile;
            var downloadUrl = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement(
              'a'
            ) as HTMLAnchorElement;
            a.href = downloadUrl;
            a.download = fileDetails.recordName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          });
      } else {
        this.gfmservice
          .downloadGFMFile(
            object,
            this.complianceEngine,
            this.complianceEngineUrl,
            this.governanceUrl,
            this.gemAccessURL,
            isShared,
            this.gfmRecordId
          )
          .then((responseDownloadFile) => {
            var blob = new Blob();
            blob = responseDownloadFile;
            var downloadUrl = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement(
              'a'
            ) as HTMLAnchorElement;
            a.href = downloadUrl;
            a.download = fileDetails.recordName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          });
      }
    } else {
      this.gfmservice
        .downloadZipFileById(
          object,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.governanceUrl,
          this.gemAccessURL,
          isShared,
          this.gfmRecordId
        )
        .then((responseDownloadFile) => {
          var blob = new Blob();
          blob = responseDownloadFile;
          var downloadUrl = URL.createObjectURL(blob);
          const a: HTMLAnchorElement = document.createElement(
            'a'
          ) as HTMLAnchorElement;
          a.href = downloadUrl;
          a.download = fileDetails.recordName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(downloadUrl);
        });
    }
  }
  openFileInNewTab(fileDetails) {
    console.log("fileDetailsfileDetails", fileDetails);
    
    this.title = fileDetails.recordName;
    this.fileExtension = fileDetails.recordName.split(".").slice(-1);
    var path = `${fileDetails.recordPath}/${fileDetails.recordName}`;
    var stringLocation = path.indexOf(fileDetails.recordName);
    var recordPath = '';
    if (stringLocation >= 0) {
      recordPath = path.substring(stringLocation - 1, -1);
    } else {
      // recordPath = fileDetails.recordPath;
      recordPath = path;
    }      
    
    var object = {
      recordName: fileDetails.recordName,
      recordPath: recordPath,
      id: fileDetails.recordPath.split('/')[0]
    };

    this.gfmservice
    .downloadGFMFile(
      object,
      this.complianceEngine,
      this.complianceEngineUrl,
      this.governanceUrl,
      this.gemAccessURL,
      'false',
      fileDetails.gfmRecordId
    )
    .then((responseDownloadFile) => {
      let blob = new Blob([responseDownloadFile], {type: "application/pdf"});
      var downloadUrl = URL.createObjectURL(blob);
      
      // Check if download access is allowed
      if (this.allowDownloadAccess) {
        // Normal PDF viewing with all controls
        this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(downloadUrl);
      } else {
        // Read-only mode - disable PDF controls and interactions
        // Use multiple PDF parameters to disable as many controls as possible
        var readOnlyUrl = downloadUrl + '#toolbar=0&navpanes=0&scrollbar=1&view=FitH&pagemode=none&print=0&download=0&search=0&zoom=page-fit&page=1&statusbar=0&messages=0&scrollbar=0';
        this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(readOnlyUrl);
      }
      
      this.showFileViewer = true;
      
      // Add document-level event listeners for read-only mode
      if (!this.allowDownloadAccess) {
        this.addReadOnlyEventListeners();
      }
    });      

  }

  // Method to close the file viewer
  closeFileViewer() {
    this.showFileViewer = false;
    this.iframeURL = null;
    this.title = null;
    // Remove read-only event listeners when closing
    this.removeReadOnlyEventListeners();
  }

  // Method to toggle download access (for admin control)
  toggleDownloadAccess() {
    this.allowDownloadAccess = !this.allowDownloadAccess;
  }

  // Method to handle iframe load event for additional security
  onIframeLoad(event: any) {
    if (!this.allowDownloadAccess) {
      try {
        const iframe = event.target;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        
        if (iframeDoc) {
          // Disable right-click context menu inside iframe
          iframeDoc.addEventListener('contextmenu', (e: Event) => {
            e.preventDefault();
            return false;
          });
          
          // Disable text selection inside iframe
          iframeDoc.addEventListener('selectstart', (e: Event) => {
            e.preventDefault();
            return false;
          });
          
          // Disable drag and drop inside iframe
          iframeDoc.addEventListener('dragstart', (e: Event) => {
            e.preventDefault();
            return false;
          });
          
          // Add CSS to further restrict interactions
          const style = iframeDoc.createElement('style');
          style.textContent = `
            * {
              -webkit-user-select: none !important;
              -moz-user-select: none !important;
              -ms-user-select: none !important;
              user-select: none !important;
              -webkit-touch-callout: none !important;
              -webkit-tap-highlight-color: transparent !important;
            }
            body {
              pointer-events: none !important;
            }
            .textLayer {
              pointer-events: none !important;
            }
          `;
          iframeDoc.head.appendChild(style);
        }
      } catch (error) {
        // Cross-origin restrictions may prevent access to iframe content
        console.log('Cannot access iframe content due to security restrictions');
      }
    }
  }

  // Add event listeners for read-only mode protection
  private addReadOnlyEventListeners() {
    // Prevent right-click context menu on the entire modal
    document.addEventListener('contextmenu', this.preventContextMenu, true);
    document.addEventListener('selectstart', this.preventSelection, true);
    document.addEventListener('dragstart', this.preventDragStart, true);
  }

  // Remove event listeners when file viewer is closed
  private removeReadOnlyEventListeners() {
    document.removeEventListener('contextmenu', this.preventContextMenu, true);
    document.removeEventListener('selectstart', this.preventSelection, true);
    document.removeEventListener('dragstart', this.preventDragStart, true);
  }

  // Event handler methods
  private preventContextMenu = (e: Event) => {
    if (!this.allowDownloadAccess && this.showFileViewer) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  private preventSelection = (e: Event) => {
    if (!this.allowDownloadAccess && this.showFileViewer) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  private preventDragStart = (e: Event) => {
    if (!this.allowDownloadAccess && this.showFileViewer) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }



  shareRecords() {
    $('#shareFileModal').modal('toggle');
  }

  // Move file/folder functionality
  openMoveDialog(item: any, index: number) {
    this.selectedItemToMove = item;
    this.selectedDestinationFolder = null;
    
    // Show spinner while loading all folders
    this.showSpinner = true;
    
    // Get ALL folders from root level to show complete hierarchy
    this.getAllFoldersForMoveDialog();
    
    $('#moveFileModal').modal('show');
  }

  // Method to get all folders for move dialog
  getAllFoldersForMoveDialog() {
    // Create root-level recordDetails to get all folders
    const rootRecordDetails = {
      recordPath: this.baseFileManagerPath,
      recordName: 'Root Directory',
      recordType: 'folder'
    };

    this.gfmservice
      .getAllFilesAndFolders(
        rootRecordDetails,
        this.complianceEngine,
        this.complianceEngineUrl,
        this.governanceUrl,
        this.gemAccessURL,
        this.isCompliance
      )
      .then((response) => {
        this.showSpinner = false;
        const rootFolders = response.allFoldersList || [];
        
        // Start with root folders and recursively fetch all subfolders
        this.getAllNestedFolders(rootFolders, 0).then(allFolders => {
          // Filter folders by company and exclude the current folder
          this.availableFolders = [
            { recordName: 'Root Directory', recordPath: this.baseFileManagerPath, isRoot: true },
            ...allFolders
              .filter(folder => folder.companyId === this.companyID)
              .filter(folder => folder.gfmRecordId !== this.selectedItemToMove.gfmRecordId) // Exclude current folder
              .map(folder => ({
                recordName: folder.recordName,
                recordPath: folder.recordPath,
                gfmRecordId: folder.gfmRecordId,
                isRoot: false
              }))
          ];
          
          console.log('Available folders for move (including nested):', this.availableFolders);
        });
      })
      .catch((error) => {
        this.showSpinner = false;
        console.error('Error loading folders for move dialog:', error);
        // Fallback to current folderList if API fails
        this.availableFolders = [
          { recordName: 'Root Directory', recordPath: this.baseFileManagerPath, isRoot: true },
          ...this.folderList.filter(folder => folder.gfmRecordId !== this.selectedItemToMove.gfmRecordId)
        ];
      });
  }

  // Recursive method to get all nested folders
  async getAllNestedFolders(folders: any[], depth: number = 0): Promise<any[]> {
    let allFolders = [...folders];
    
    // Limit depth to prevent infinite recursion
    if (depth > 5) {
      console.warn('Maximum folder depth reached (5 levels)');
      return allFolders;
    }

    // Process each folder to get its subfolders
    for (const folder of folders) {
      try {
        const folderRecordDetails = {
          recordPath: folder.recordPath,
          recordName: folder.recordName,
          recordType: 'folder'
        };

        const response = await this.gfmservice.getAllFilesAndFolders(
          folderRecordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.governanceUrl,
          this.gemAccessURL,
          this.isCompliance
        );

        const subFolders = response.allFoldersList || [];
        if (subFolders.length > 0) {
          // Recursively get subfolders of subfolders
          const nestedSubFolders = await this.getAllNestedFolders(subFolders, depth + 1);
          allFolders = [...allFolders, ...nestedSubFolders];
        }
      } catch (error) {
        console.warn(`Error fetching subfolders for ${folder.recordName}:`, error);
        // Continue with other folders even if one fails
      }
    }

    return allFolders;
  }

  // Helper method to get folder display name with hierarchy
  getFolderDisplayName(folder: any): string {
    if (!folder || !folder.recordPath) {
      return folder.recordName || 'Unknown Folder';
    }

    // Extract the folder hierarchy from recordPath
    const pathParts = folder.recordPath.split('/');
    const basePath = this.baseFileManagerPath;
    
    // Remove the base path to get relative path
    let relativePath = folder.recordPath;
    if (folder.recordPath.startsWith(basePath)) {
      relativePath = folder.recordPath.substring(basePath.length);
      if (relativePath.startsWith('/')) {
        relativePath = relativePath.substring(1);
      }
    }

    // If there's a relative path, show the hierarchy
    if (relativePath && relativePath !== folder.recordName) {
      const pathSegments = relativePath.split('/');
      const folderName = pathSegments[pathSegments.length - 1];
      
      // Show hierarchy with indentation
      const depth = pathSegments.length - 1;
      const indent = '  '.repeat(depth);
      return `${indent}${folderName}`;
    }

    return folder.recordName;
  }

  // Reusable alert helpers
  successMessage: string = '';
  errorMessage: string = '';

  showSuccess(message: string) {
    this.successMessage = message || 'Success';
    // Defer to next tick so Angular updates the bound text before showing
    setTimeout(() => {
      this.safeShow('#actionSuccessModal');
      this.autoHide('#actionSuccessModal');
    }, 0);
  }

  showError(message: string) {
    this.errorMessage = message || 'Something went wrong';
    setTimeout(() => {
      this.safeShow('#actionErrorModal');
      this.autoHide('#actionErrorModal');
    }, 0);
  }

  // Ensure modal shows without blocking backdrop and cleans up
  private safeShow(selector: string) {
    try {
      // Remove any stale backdrops
      $('.modal-backdrop').remove();
      // Force show without backdrop
      const $modal = ($(selector) as any);
      $modal.appendTo('body');
      $modal.modal({ backdrop: false, keyboard: true, show: true });
    } catch (e) {
      console.warn('Modal show failed', e);
    }
  }

  private autoHide(selector: string, delayMs: number = 2500) {
    try {
      setTimeout(() => {
        try {
          ($(selector) as any).modal('hide');
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open');
        } catch {}
      }, delayMs);
    } catch {}
  }

  confirmMove() {
    if (!this.selectedItemToMove || !this.selectedDestinationFolder) {
      this.showError('Please select a destination folder.');
      return;
    }

    const targetPath = this.selectedDestinationFolder.isRoot 
      ? this.baseFileManagerPath 
      : this.selectedDestinationFolder.recordPath;

    console.log('=== MOVE DIALOG DEBUG ===');
    console.log('Selected destination folder:', this.selectedDestinationFolder);
    console.log('Selected destination recordPath:', this.selectedDestinationFolder.recordPath);
    console.log('Selected destination recordName:', this.selectedDestinationFolder.recordName);
    console.log('Calculated targetPath:', targetPath);
    console.log('=========================');

    // Use the new backend move API
    this.moveItemUsingBackendAPI(this.selectedItemToMove, targetPath);
  }

  moveItemUsingBackendAPI(item: any, targetPath: string) {
    const moveData = {
      gfmRecordId: item.gfmRecordId,
      recordName: item.recordName,
      recordPath: item.recordPath,
      recordType: item.recordType,
      targetRecordPath: targetPath
    };

    console.log('=== FRONTEND MOVE REQUEST ===');
    console.log('Item:', item);
    console.log('Target Path:', targetPath);
    console.log('Move Data:', moveData);
    console.log('Current recordDetails:', this.recordDetails);
    console.log('gemAccessURL:', this.gemAccessURL);
    console.log('Full URL will be:', this.gemAccessURL + 'gfm/moveFileOrFolder');
    console.log('============================');

    this.gfmservice.moveFileOrFolder(
      moveData,
      this.complianceEngine,
      this.complianceEngineUrl,
      this.governanceUrl,
      this.gemAccessURL
    ).then(response => {
      console.log('=== MOVE RESPONSE ===');
      console.log('Response:', response);
      console.log('Response status:', response?.status);
      console.log('Response message:', response?.message);
      console.log('=====================');
      
      if (response && response.status === 0) {
        // Refresh the current view to show updated file locations
        this.getAllFilesAndFolders(
          this.recordDetails,
          this.complianceEngine,
          this.complianceEngineUrl,
          this.isCompliance
        );
        $('#moveFileModal').modal('hide');
        this.showSuccess('Moved successfully!');
      } else {
        const errorMsg = response?.message || 'Unknown error occurred';
        console.error('Move failed with message:', errorMsg);
        this.showError(`Failed to move item: ${errorMsg}`);
        $('#moveFileModal').modal('hide');
      }
    }).catch(error => {
      console.error('=== MOVE ERROR ===');
      console.error('Error:', error);
      console.error('Error status:', error?.status);
      console.error('Error message:', error?.message);
      console.error('==================');
      this.showError('Error occurred while moving item.');
      $('#moveFileModal').modal('hide');
    });
  }

  serachFileRedirect(searchResult) {
    console.log('serachFileRedirect', searchResult);
    // Set active tab to 'files' when searching
    this.activeTab = 'files';
    this.filesPage = 1;
    var tempPath = JSON.parse(this.recordDetails);
    if (searchResult.recordPath == tempPath.recordPath) {
      this.searchResultsList = [];
    }
    var recordPath = '';
    if (searchResult.recordType == 'folder') {
      recordPath = searchResult.recordPath + '/' + searchResult.recordName;
      this.recordDetails = safeJsonStringify({
        recordPath: searchResult.recordPath + '/' + searchResult.recordName,
      });
    } else {
      recordPath = searchResult.recordPath;
      this.recordDetails = safeJsonStringify({
        recordPath: searchResult.recordPath,
      });
    }

    var indexbackS = recordPath.indexOf('/');

    recordPath = this.replaceBetween(
      recordPath,
      0,
      indexbackS,
      this.baseFileManagerPath
    );

    var index = recordPath.indexOf(this.baseFileManagerPath);
    var pathstring = recordPath;
    var path = '';
    console.log(
      'recordPath,this.baseFileManagerPath',
      recordPath,
      this.baseFileManagerPath
    );
    if (index >= 0) {
      path = recordPath.slice(index, _.size(this.baseFileManagerPath));
      var newpath = '';
      console.log('path', path);
      console.log('recordPath', recordPath);
      console.log('pathstring', pathstring);
      newpath = pathstring.substring(_.size(path), _.size(recordPath));
    }
    console.log('newpath', newpath);
    if (newpath.charAt(0) == '/') {
      newpath = newpath.substring(1, _.size(newpath));
    }

    if (newpath.charAt(_.size(newpath) - 1) == '/') {
      newpath = newpath.substring(_.size(newpath) - 1, -1);
    }

    this.breadcrumbs = newpath.split('/');
    newpath = newpath.trim();
    var newLink = this.serialize(this.parse(newpath));
    this.gfmRecordIdForFolder = searchResult.gfmRecordId;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    if (searchResult.sharedDoc) {
      this.router.navigate(
        [
          'structure',
          { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
        ],
        {
          queryParams: {
            gfmRecordId: this.gfmRecordIdForFolder,
            sharedFolder: 'true',
          },
        }
      );
    } else {
      this.router.navigate(
        [
          'structure',
          { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
        ],
        { queryParams: { isCompliance: searchResult.isComplianceFile } }
      );
    }
    //below code has been commented out for breadcrum navigation which will handle aall routing and incoming get calls for that folder
    // this.gfmservice.getAllFilesAndFolders(this.recordDetails, this.complianceEngine, this.complianceEngineUrl).then(response => {
    //   //console.log("get response", response)
    //   this.gfmResponse = response;
    //   this.fileList = this.gfmResponse.allFilesList;
    //   this.recentFileList = this.gfmResponse.allRecentFilesList;
    //   this.folderList = this.gfmResponse.allFoldersList;
    //   this.uploadForm.controls.searchByValue.reset();
    //   this.searchResultsList = [];
    // })
  }

  replaceBetween(origin, startIndex, endIndex, insertion) {
    return (
      origin.substring(0, startIndex) + insertion + origin.substring(endIndex)
    );
  }

  navigationLink(redirectionLink, index) {
    // console.log("redirectionLink",redirectionLink)
    // console.log("index",index)
    // console.log("breadcrumbs",this.breadcrumbs)
    this.isSharedFolder = localStorage.getItem('isSharedFolder');
    if (index == null) {
      localStorage.setItem('isSharedFolder', 'false');
    }
    var link = '';
    if (index == null) {
      link = '';
    } else {
      var count = 0;
      for (; count <= index; count++) {
        link = link.concat(this.breadcrumbs[count], '/').trim().toString();
      }
    }
    if (link.charAt(0) == '/') {
      link = link.substring(1, _.size(link));
    }

    var newLink = this.serialize(this.parse(link));
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    if (this.sharedFolder == true && index != null) {
      this.router.navigate(
        [
          'structure',
          { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
        ],
        {
          queryParams: {
            gfmRecordId: this.gfmRecordIdForFolder,
            sharedFolder: 'true',
          },
        }
      );
    } else {
      this.router.navigate([
        'structure',
        { outlets: { 'structure-outlet': ['gfmDashboard', newLink] } },
      ]);
    }
  }

  navigationFunction(recordPath) {
    var index = this.baseFileManagerRecordPathWithParams.indexOf(
      this.baseFileManagerPath
    );
    var pathstring = this.baseFileManagerRecordPathWithParams;
    var path = '';

    if (index >= 0) {
      path = this.baseFileManagerRecordPathWithParams.slice(
        index,
        _.size(this.baseFileManagerPath)
      );
      var newpath = '';
      newpath = pathstring.substring(
        _.size(path),
        _.size(this.baseFileManagerRecordPathWithParams)
      );
    }

    if (newpath.charAt(0) == '/') {
      newpath = newpath.substring(1, _.size(newpath));
    }

    if (newpath.charAt(_.size(newpath) - 1) == '/') {
      newpath = newpath.substring(_.size(newpath) - 1, -1);
    }

    var pathToParse = newpath;
    this.breadcrumbs = newpath.split('/');

    if (_.size(this.breadcrumbs) <= 1 && this.breadcrumbs[0] == '') {
      this.showBreadCrumpath = false;
    } else {
      this.showBreadCrumpath = true;
    }

    var newLink = this.serialize(this.parse(newpath));
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return true;
    };
    this.getAllFilesAndFolders(
      this.recordDetails,
      this.complianceEngine,
      this.complianceEngineUrl,
      this.isCompliance
    );
  }

  shareCheckType(file, i, p) {
    if (p == 'download') {
      this.downloadGFMFileDialogBox(file, i, 'shareFiles', 'true');
    }
    if (p == 'share') {
      this.shareFileDialogBox(file, i);
    }
  }

  tagPopForFolders() {
    var self = this;
    var modal = document.getElementById('myModal');
    modal.style.display = 'none';
    const modalRef = this.modalService.open(TagPopupComponentComponent, {
      backdrop: 'static',
    });

    var tagsToSend = [];
    if (_.size(this.selectedTagsForFolder)) {
      _.forEach(self.selectedTagsForFolder, function (element) {
        tagsToSend.push(element.value);
      });
    }

    var fileDetail = {
      tags: tagsToSend,
    };

    modalRef.componentInstance.isFolderCreation = true;
    modalRef.componentInstance.complianceEngine = this.complianceEngine;
    modalRef.componentInstance.complianceEngineUrl = this.complianceEngineUrl;
    modalRef.componentInstance.fileDetail = fileDetail;
    modalRef.componentInstance.governanceUrl = this.governanceUrl;
    modalRef.componentInstance.gemAccessURL = this.gemAccessURL;
    modalRef.result
      .then((resp) => {
        modal.style.display = 'initial';
        this.selectedTagsForFolder = resp;
        // $('#myModal').toggle('toggle');
      })
      .catch((error) => {
        modal.style.display = 'initial';
        // this.selectedTagsForFolder = resp;
      });
  }

  removeSelectedTagsForFolder(tag) {
    var self = this;
    if (_.size(this.selectedTagsForFolder) > 0) {
      var found = _.findIndex(self.selectedTagsForFolder, function (element) {
        return _.get(element, 'value') == tag.value;
      });
      if (found >= 0) {
        self.selectedTagsForFolder.splice(found, 1);
      }
    }
  }

  rightClick(event, file, i, menuName) {
    $('#' + menuName + i).toggle('show');
    event.preventDefault();
  }

  filterShareList(shareList){
   var filtered_shareList = shareList.filter(file=>{
    if(file.recordPath.includes("/")){
      return false;
    }else{
      return true;
    }
   })
    
   return filtered_shareList;

  }

  // Method to get file type icon based on file extension
  getFileIcon(fileName: string): string {
    if (!fileName) return 'fa fa-file-o';
    
    const extension = fileName.split('.').pop()?.toLowerCase();
    
    switch (extension) {
      // PDF files - Adobe Red
      case 'pdf':
        return 'fa fa-file-pdf-o';
      
      // Excel files - Microsoft Green
      case 'xlsx':
      case 'xls':
        return 'fa fa-file-excel-o';
      
      // Word documents - Microsoft Blue
      case 'docx':
      case 'doc':
        return 'fa fa-file-word-o';
      
      // PowerPoint files - Microsoft Orange
      case 'pptx':
      case 'ppt':
        return 'fa fa-file-powerpoint-o';
      
      // Text files - Gray
      case 'txt':
        return 'fa fa-file-text-o';
      
      // CSV files - Excel Green
      case 'csv':
        return 'fa fa-file-excel-o';
      
      // Image files - Purple
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
      case 'svg':
        return 'fa fa-file-image-o';
      
      // Video files - Red
      case 'mp4':
      case 'avi':
      case 'mov':
      case 'wmv':
        return 'fa fa-file-video-o';
      
      // Audio files - Green
      case 'mp3':
      case 'wav':
      case 'aac':
        return 'fa fa-file-audio-o';
      
      // Archive files - Brown
      case 'zip':
      case 'rar':
      case '7z':
        return 'fa fa-file-archive-o';
      
      // Code files - Dark Blue
      case 'js':
      case 'ts':
      case 'html':
      case 'css':
      case 'json':
      case 'xml':
        return 'fa fa-file-code-o';
      
      // Default file icon - Gray
      default:
        return 'fa fa-file-o';
    }
  }

 

}
